<div class="main-container">
    <div class="waiting-container">
        <h1>{{ "Choose a tour you want to attend" | translate}}</h1>
        <select class="waiting" [(ngModel)]="selectedMission">
            <option value="null" disabled>{{'Choose a tour' | translate}}</option>
            <option *ngFor="let mission of missions" [ngValue]="mission">
                {{mission.space.name}} - {{mission.templateMission ? mission.templateMission.title : "Visite libre"}}</option>
        </select>
        <button class="btn-validate-visit" (click)="onGoToVisit()"  [disabled]="!selectedMission">{{'Validate' | translate}}</button>
    </div>
</div>